import React from "react";

const Link = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();

  return (
    <a
      href={url}
      // title={url}
      style={{
        color: "blue",
        cursor: "pointer",
      }}
      onClick={() => window.open(url)}
    >
      {props.children}
    </a>
  );
};

export default Link;
